import { AttachmentService } from 'src/app/services/attachment.service';
import { Vehicle } from 'src/app/models/Vehicle';
import { Component, Input, OnInit } from '@angular/core';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { IconService } from './../../../services/icon.service';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';


@Component({
  selector: 'vehicle-card-for-modal',
  templateUrl: './vehicle-card-for-modal.component.html',
  styleUrls: ['./vehicle-card-for-modal.component.scss']
})
export class VehicleCardForModalComponent implements OnInit {

  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;


  //#region Vehicle Type
  classSearch?: boolean = false;
  vehicleSearch?: boolean = false;
  MakeModelYearSearch?: boolean = false;
  //#endregion
  @Input() vehicle:Vehicle;
  constructor(
    private attachmentService:AttachmentService,
    private iconService:IconService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer, ) {
    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );
   }

  ngOnInit() {
    if(this.vehicle!=null){
      if(this.vehicle.vehicleID!=null){
        this.vehicleSearch=true;
      }
      else if(this.vehicle.makeID!=null&&this.vehicle.modelID!=null&&this.vehicle.year!=null){
        this.MakeModelYearSearch=true;
      }
      else{
        this.classSearch=true;
      }
    }

  }
  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }

}
